import {
  type CreateMultipartUploadOptions,
  createMultipartUpload as createSharedMultipartUpload,
  type MultipartUploadHandle,
} from "@vericus/cadmus-media-upload";

import * as config from "@/config";

import { __GLOBAL_ASSESSMENT_ID } from "./globals";
import { multipartUploadHeaders } from "./headers";

export type {
  CreateMultipartUploadOptions,
  MultipartUploadHandle,
  UploadedMedia,
} from "@vericus/cadmus-media-upload";
export {
  MultipartUploadError,
  PantheonApiError,
} from "@vericus/cadmus-media-upload";

/** Aphrodite media uploads via the shared multipart helper. */
export function createMultipartUpload(
  file: File,
  opts: CreateMultipartUploadOptions = {}
): MultipartUploadHandle {
  return createSharedMultipartUpload({
    file,
    onProgress: opts.onProgress,
    // Longer ladder than Uppy's default so short connection dips recover
    // automatically before the upload is declared failed.
    retryDelays: opts.retryDelays ?? [0, 1000, 3000, 5000, 10000, 20000],
    apiEndpoint: config.API_ENDPOINT,
    assessmentId: () => __GLOBAL_ASSESSMENT_ID.current,
    createHeaders: multipartUploadHeaders,
  });
}
